export interface ManpowerSubRequirementGroup {
  id: string;
  name: string;
}
